<template>
  <div id="config-config-slide-show-editor">
    <CRow>
      <CCol xs="12" md="12" lg="12">
        <CCard style="border-radius: unset!important;">
          <CCardHeader
            style="border-radius: unset!important;position: unset!important;background: white!important;border-bottom: unset!important;"
            color="light" class="d-inline-flex justify-content-between align-items-center">
            <strong style="font-size: 18px;padding: 8px 0px;width: 100%;border-bottom: 1px solid #d8dbe0;">
              {{ getTitleHeader }}
            </strong>
          </CCardHeader>

          <CCardBody style="padding: unset!important; min-height: 70vh;">

            <template v-if="action === actionEditor.LAYOUT_SETTING">
              <div class="content-fade-in">
                <CCol xs="12" md="12" lg="12">
                  <BaseSelect :options="typeSelect.options" :data="typeSelect.data" ref="typeSelect"></BaseSelect>
                </CCol>
                <CCol xs="12" md="12" lg="12">
                  <BaseSelect :options="ratioSelect.options" :data="ratioSelect.data" ref="ratioSelect"></BaseSelect>
                </CCol>
                <hr class="mt-4" />

                <div class="group-layer-setting">
                  <div class="card-header d-inline-flex justify-content-between align-items-center bg-light title">
                    Bố cục giao diện
                  </div>
                  <CCol xs="12" md="12" lg="12">
                    <template v-if="items != null && items.length > 0">
                      <draggable :list="items" class="layers-wrapper" ghost-class="ghost" group="people"
                        :move="checkMoveLayer" @start="drag=true" @end="drag=false">
                        <ul v-for="(element) in items">
                          <li class="layout_layer">
                            <span class="description" style="width: 85%;" @click.self="activeLayer(element.id)">
                              {{ getTitleLayer(element) }}
                            </span>
                            <div class="text-right" @click="removeLayer(element.id)">
                              <i class="fa fa-trash" v-c-tooltip.hover="'Xóa'"></i>
                            </div>
                          </li>
                        </ul>
                      </draggable>
                    </template>
                    <template v-else>
                      <span class="no-layers-content-message" :class="isValidSubmit ? 'valid-error' : ''">Chưa có nội
                        dung nào!</span>
                    </template>
                  </CCol>
                </div>
              </div>
            </template>

            <template v-else-if="action === actionEditor.ADD_LAYER">
              <div class="fadeInUp fade animated">
                <CRow style="margin: unset;padding: 15px;">
                  <template v-for="itemChoose of itemsLayerChoose">
                    <CCol :key="itemChoose.id" xs="12" md="12" lg="12" xl="6" class="layout-insert-item-column mb-3">
                      <div class="layout-insert-item-type" :class="itemChoose.disabled ? 'disabled' : ''"
                        @click="chooseLayer(itemChoose)">
                        <span style="color: #000000b3;width: 70%;font-weight: 500;">{{ itemChoose.title }}</span>
                        <!--                        <i class="fa" :class="itemChoose.icon"></i>-->
                      </div>
                      <!--                      <span class="layout-insert-item-label"> {{ itemChoose.title }} </span>-->
                    </CCol>
                  </template>
                </CRow>
              </div>
            </template>

            <template v-else-if="action === actionEditor.EDITOR_LAYER">
              <!--              <ConfigSlideShowFormEditor :type="items[itemSelected].extractData.typeLayer" :item="items[itemSelected]"/>-->
              <SlideShowFormEditor :type="items[itemSelected].extractData.typeLayer" :item="items[itemSelected]" />
            </template>

          </CCardBody>

          <CCardFooter style="text-align: center" class="mt-2">
            <CButton color="primary" class="btn-action-primary mr-2" @click="submitSaveSlideShow()">
              <i class="fa fa-save"></i> Lưu lại
            </CButton>
            <CButton color="secondary" class="btn-action-primary" @click="$router.go(-1)">
              <i class="fa fa-reply"></i> Hủy bỏ
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal title="Thêm Tỷ lệ Tùy chỉnh" :show.sync="customRatio.isShowModal" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          <BaseInput :options="customRatio.nameRatio.options" :data="customRatio.nameRatio.data"
            class="input-wrapper" />
        </CCol>
        <CCol xs="6" md="6" lg="6" xl="6">
          <BaseInput :options="customRatio.widthRatio.options" :data="customRatio.widthRatio.data"
            class="input-wrapper" />
        </CCol>
        <CCol xs="6" md="6" lg="6" xl="6">
          <BaseInput :options="customRatio.heightRatio.options" :data="customRatio.heightRatio.data"
            class="input-wrapper" />
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-primary" :disabled="customRatio.loading.value"
          @click="submitAddCustomRatio()">
          <i class="fa " :class="customRatio.loading.value ? 'fa-spinner fa-spin' : 'fa-check'"></i> Lưu
        </button>
        <button type="button" class="btn btn-secondary" @click="customRatio.isShowModal = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>

      </template>
    </CModal>
  </div>
</template>
<script>

import BaseSelect from "@/views/base/BaseSelect2";
import draggable from 'vuedraggable'
import { ActionEditor, TypeChooseLayer } from "@/constant";
import SlideShowFormEditor from "@/views/slide_show/SlideShowFormEditor";
import BaseInput from "@/views/base/BaseInput";

export default {
  name: 'ConfigSlideShowEditor',
  components: { SlideShowFormEditor, BaseSelect, draggable, BaseInput },
  props: {
    items: Array,
    action: {
      type: Number
    },
    type: Number,
    itemSelected: Number,
    size: Object,
    ratio: {
      type: String,
    },
    
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      addCustomRatioModal: false,
      customRatio: {
        isShowModal: false,
        loading: {value: false},
        nameRatio: {
          options: {
            placeholder: "Tên tỷ lệ",
            label: 'Tên tỷ lệ <i class="valid-error">*</i>'
          },
          data: {
            name: "name",
            model: '',
            updateCallback: function () {
              that.submitAddCustomRatio();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.customRatio.nameRatio.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Tên tỷ lệ không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          },
        },
        widthRatio: {
          options: {
            placeholder: "Chiều rộng",
            label: 'Chiều rộng',
            maxlength: 4,
            addInputClasses: "widthCustomRatio",
          },
          data: {
            name: "width",
            model: '',
            updateCallback: function () {
              that.submitAddCustomRatio();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.customRatio.widthRatio.data.model.replace(/[^\w\s]/gi, '');
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Chiều rộng không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          },
        },
        heightRatio: {
          options: {
            placeholder: "Chiều cao",
            label: 'Chiều cao',
            maxlength: 4,
            addInputClasses: "widthCustomRatio",
          },
          data: {
            name: "height",
            model: '',
            updateCallback: function () {
              that.submitAddCustomRatio();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.customRatio.heightRatio.data.model.replace(/[^\w\s]/gi, '');
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Chiều cao không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          },
        },
      },
      loading: { value: false },
      actionEditor: ActionEditor,
      typeLayer: TypeChooseLayer,
      typeSelect: {
        options: {
          filter: false,
          label: "Loại",
          'keyField': 'key',
          'valueField': 'value',
        },
        data: {
          name: "type",
          model: that.type,
          items: [
            { key: "0", value: "Toàn màn hình" },
            { key: "1", value: "Phân 3 vùng" },
          ],
        }
      },
      ratioSelect: {
        options: {
          filter: false,
          label: "Ratio <i class='add-custom-ratio' id='addCustomRatio'>Add custom ratio</i>",
          customOptions: true,
          keyField: "value",
          valueField: "text",
        },
        data: {
          name: "ratio",
          model: that.ratio != null ? that.ratio : '16:9',
          items: [],
        }
      },
      itemsLayerChoose: [
        { id: 1, typeLayer: TypeChooseLayer.AREA_TEXT, title: 'Vùng văn bản', icon: 'fa-file-text', disabled: false },
        { id: 2, typeLayer: TypeChooseLayer.AREA_LEFT, title: 'Vùng trái', icon: 'fa-left', disabled: false },
        { id: 3, typeLayer: TypeChooseLayer.AREA_RIGHT, title: 'Vùng phải', icon: 'fa-right', disabled: false },
      ],
      isValidSubmit: false,
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    getTitleHeader() {
      if (this.action === this.actionEditor.LAYOUT_SETTING) {
        return 'Cài đặt giao diện';
      } else if (this.action === this.actionEditor.ADD_LAYER) {
        return 'Thêm giao diện';
      } else if (this.action === this.actionEditor.EDITOR_LAYER) {
        var itemSelected = this.items[this.itemSelected];
        switch (itemSelected.extractData.typeLayer) {
          case this.typeLayer.AREA_TEXT: {
            return 'Cấu hình vùng chữ';
          }
          case this.typeLayer.AREA_LEFT: {
            return 'Cấu hình vùng trái';
          }
          case this.typeLayer.AREA_RIGHT: {
            return 'Cấu hình vùng phải';
          }
          case this.typeLayer.FULL_SCREEN: {
            return `Cấu hình toàn màn hình`;
          }
        }
      }
    },
  },
  created() {
    this.loadRatio();
  },
  mounted() {
    let that = this;
    document.getElementById("addCustomRatio").onclick = function () {
      that.addCustomRatio();
    }
  },
  methods: {
    getTitleLayer(item) {
      switch (item.extractData.typeLayer) {
        case this.typeLayer.AREA_TEXT: {
          return `Vùng văn bản`;
        }
        case this.typeLayer.AREA_LEFT: {
          return `Vùng trái`;
        }
        case this.typeLayer.AREA_RIGHT: {
          return `Vùng phải`;
        }
        case this.typeLayer.FULL_SCREEN: {
          return `Toàn màn hình`;
        }
      }
    },
    checkMoveLayer(e) {
      this.$emit("change:layer", e);
    },
    activeLayer(id) {
      this.$emit("active:layer", id);
    },
    removeLayer(id) {
      this.$emit("remove:layer", id);
    },
    chooseLayer(element) {
      if (!element.disabled) {
        this.$emit("choose:layer", element);
      }
    },
    validateItems() {
      if (this.items && this.items.length === 0) {
        this.isValidSubmit = true;
      } else {
        this.isValidSubmit = false;
      }
    },
    submitSaveSlideShow() {
      this.validateItems();
      if (this.isValidSubmit) {
        this.showErrorMsg({ message: 'Vui lòng kiểm tra tiêu đề và bố cục giao diện' });
        return;
      }
      let that = this;
      this.$emit("loading", true);
      var items = [];
      this.items.map(each => {
        var item = Object.assign({}, each);
        delete item.extractData;
        var _extractData = each.extractData;
        item.active = false;
        item.extractData = {
          // id: _extractData.id ? _extractData.id : null,
          typeLayer: _extractData.typeLayer,
        }
        items.push(item);
      })
      var _urlAPI = '/config_slide_show_central/add';
      var objDataRequest = {
        widthDesign: that.size.width,
        heightDesign: that.size.height,
        ratio: that.ratioSelect.data.model,
        type: this.typeSelect.data.model,
        draggableModels: items
      };
      if (this.$route.params.id) {
        objDataRequest.id = this.$route.params.id;
        _urlAPI = '/config_slide_show_central/update';
      }
      this.$helper.loadDataSource({
        url: _urlAPI,
        dataSubmit: function () {
          return objDataRequest;
        },
        ignoreDefaultData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.$emit("loading", false);
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
          } else {
            if (that.$route.params.id) {
              that.showSuccessMsg({ message: "Cập nhật trình diễn thành công" });
            } else {
              that.showSuccessMsg({ message: "Thêm mới trình diễn thành công" });
            }
            that.$router.push("/files-screen-management/slide-show-central.html");
          }
        },
        errorCallback: function (error) {
          that.$emit("loading", true);
          that.$helper.handleError(that.$router, error);
        },
      });
    },

    addCustomRatio() {
      this.customRatio.isShowModal = true;
      this.setupInputRatioNumber('widthCustomRatio');
      this.setupInputRatioNumber('heightCustomRatio');
    },
    loadRatio(ratio) {
      let that = this;
      that.isShowModal = true;
      that.$emit("loading", true);
      this.$helper.loadDataSource({
        url: "/ratio/find_ratio",
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            let dataLandscape = [
              {
                value: "0",
                text: 'Landscape',
                disabled: true,
                _style: "color:#260909;font-weight:bold",
                _class: "landscape-option"
              }
            ]
            let dataPortrait = [{
              value: "-1",
              text: 'Portrait',
              disabled: true,
              _style: "color:#260909;font-weight:bold",
              _class: "portrait-option"
            }]
            response.data.data.forEach(each => {
              if (each.type == 0) {   // Landscape
                dataLandscape.push(each);
              } else {        // Portrait
                dataPortrait.push(each);
              }
            })
            that.ratioSelect.data.items = dataLandscape.concat(dataPortrait);
            if (ratio) {
              setTimeout(() => {
                that.ratioSelect.data.model = ratio;
              }, 100)
            }
            that.$emit("load:data", true);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitAddCustomRatio() {
      let that = this;
      let isValid = true;
      isValid &= this.customRatio.nameRatio.data.validator.valid();
      isValid &= this.customRatio.widthRatio.data.validator.valid();
      isValid &= this.customRatio.heightRatio.data.validator.valid();
      if (!isValid) {
        return;
      }

      let ratio = that.convertWidthHeightToAspectRatio(that.customRatio.widthRatio.data.model, that.customRatio.heightRatio.data.model);
      let dataRequest = {
        name: that.customRatio.nameRatio.data.model,
        width: that.customRatio.widthRatio.data.model,
        height: that.customRatio.heightRatio.data.model,
        ratio: ratio
      };

      that.$helper.loadDataSource({
        loading: that.customRatio.loading,
        url: "/ratio/add",
        dataSubmit() {
          return dataRequest;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data.customRatio);
          } else {
            that.loadRatio(ratio);
            that.customRatio.isShowModal = false;
            that.clearDataAddCustomRatio();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      })
    },
    clearDataAddCustomRatio() {
      this.customRatio.nameRatio.data.model = "";
      this.customRatio.widthRatio.data.model = "";
      this.customRatio.heightRatio.data.model = "";
    },
    convertWidthHeightToAspectRatio(width, height) {
      function gcd(a, b) {
        return (b == 0) ? a : gcd(b, a % b);
      }

      var r = gcd(width, height);
      return width / r + ":" + height / r;
    },
    setupInputRatioNumber(inputCLass) {
      // eslint-disable-next-line no-undef
      let $input = $('.' + inputCLass);
      $input.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
        if (/^\d*$/.test(this.value)) {
          this.oldValue = this.value.replace(/[^\w\s]/gi, '');
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue.replace(/[^\w\s]/gi, '');
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
      });
    },
  },
  watch: {
    type(value) {
      this.typeSelect.data.model = value;
    },
    'typeSelect.data.model': function (value) {
      this.$emit("change:type", value);
    },
    items(value) {
      if (this.typeSelect.data.model == 1) {
        this.itemsLayerChoose.map(each => {
          var item = value.find(item => item.extractData.typeLayer == each.typeLayer);
          if (item) {
            each.disabled = true;
          } else {
            each.disabled = false;
          }
        })
      }
    },
    ratio(value) {
      this.ratioSelect.data.model = value;
    },
    "ratioSelect.data.model": function (value) {
      this.$emit("update:ratio", value);
    },
    action(value) {
      let that = this;
      if (value == 0) {
        setTimeout(() => {
          document.getElementById("addCustomRatio").onclick = function () {
            that.addCustomRatio();
          }
        }, 100)
      }
    }
  },
  destroyed() {
  }
}
</script>

<style scoped>
video {
  object-fit: contain;
}

.group-layer-setting .title {
  border-radius: unset !important;
  position: unset !important;
  background: white !important;
  border-bottom: unset !important;
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  padding-left: 13px;
}

.group-layer-setting .layers-wrapper ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.group-layer-setting .layers-wrapper ul>li {
  margin-bottom: 4px;
  background: #E8E9EC !important;
  border-radius: 4px;
  color: #4B4B50 !important;
  padding: 10px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.group-layer-setting .no-layers-content-message {
  font-style: italic;
  font-size: 12px;
}

.layout-insert-item-column {
  padding: 0;
  padding-right: 12px;
  text-align: center;
}

.layout-insert-item-type {
  border-radius: 3px;
  width: 100%;
  height: 80px;
  background: #dcdcdc;
  color: #fff;
  cursor: pointer;
  transition: all ease-in-out .5s;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.layout-insert-item-type:hover {
  background: rgba(157, 151, 151, 0.49);
}

.text-right {
  cursor: pointer;
  border: 1px solid #00000040;
  padding: -4px;
  border-radius: 5px;
  width: 23px;
  height: 23px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.text-right:hover {
  background: rgba(128, 128, 128, 0.3);
  color: white;
}
</style>
<style>
#config-config-slide-show-editor .group-color-picker {
  position: relative;
}

#config-config-slide-show-editor .one-colorpicker {
  position: absolute;
  top: 1px;
  right: 1px;
}

#config-config-slide-show-editor .color-block {
  width: 28px;
  height: 34px;
}

#config-config-slide-show-editor .color-block-layer.value {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

#config-config-slide-show-editor .disabled {
  cursor: no-drop !important;
  /*pointer-events: none;*/
  justify-content: center;
  align-content: center;
}
</style>
<style>
  #config-slide-show-editor .group-color-picker {
    position: relative;
  }
  
  #config-slide-show-editor .one-colorpicker {
    position: absolute;
    top: 1px;
    right: 1px;
  }
  
  #config-slide-show-editor .color-block {
    width: 28px;
    height: 34px;
  }
  
  #config-slide-show-editor .color-block-layer.value {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  
  .landscape-option:before {
    font-family: FontAwesome;
    content: '\f108';
    margin-right: 5px;
    margin-left: 5px;
  }
  
  .portrait-option:before {
    font-family: FontAwesome;
    content: '\f108';
    margin-right: 5px;
    transform: rotate(90deg);
    display: inline-block;
    margin-left: 5px;
  }
  
  .add-custom-ratio {
    position: absolute;
    right: 10px;
    cursor: pointer;
  }
  
  .add-custom-ratio:hover {
    text-decoration: underline;
    color: rgba(0, 0, 255, 0.84);
  }
  
  </style>
  
